import { AxiosError } from 'axios';
import { useCustomQuery } from '../../hooks/query';
import axiosClient from '../axiosClient';
import { GET_GROUP_EXAM_REGISTRATIONS_URL } from '../../constants/apiUrls';
import { GET_GROUP_EXAM_REGISTRATIONS_QUERY_KEY } from '../../constants/queryKeys';
import { GenericErrorResponse } from '../typings';
import { CandidateRegisteredExamListingResponse } from '../../api/candidate/exam/model';

interface Input {
  onSuccess?: (data: GroupRegisteredExamModelResponse[]) => void;
  onError?: (data: AxiosError<GenericErrorResponse>) => void;
}

export interface GroupRegisteredExamModelResponse extends CandidateRegisteredExamListingResponse {
  coordinatorName: string;
}

export const useGetCoordinatorGroupExamRegistrations = ({ onSuccess, onError }: Input) => {
  const getCoordinatorGroupExamRegistrations = async () => {
    const res = await axiosClient.get<GroupRegisteredExamModelResponse[]>(
      GET_GROUP_EXAM_REGISTRATIONS_URL
    );
    return res.data;
  };

  return useCustomQuery(
    GET_GROUP_EXAM_REGISTRATIONS_QUERY_KEY,
    getCoordinatorGroupExamRegistrations,
    {
      onSuccess,
      onError,
    }
  );
};
